const Selection = () => import(/* webpackChunkName: "v-selections" */ '@/components/page/selections/Selection')
const Selections = () => import(/* webpackChunkName: "v-selections" */ '@/components/page/selections/Selections')

const EditGateways = () => import(/* webpackChunkName: "v-selections" */ '@/components/page/selections/EditGateways')
const EditEndDevices = () => import(/* webpackChunkName: "v-selections" */ '@/components/page/selections/EditEndDevices')

const Move = () => import(/* webpackChunkName: "v-selections" */ '@/components/page/selections/Move')
const Delete = () => import(/* webpackChunkName: "v-selections" */ '@/components/page/selections/Delete')
const Workflow = () => import(/* webpackChunkName: "v-selections" */ '@/components/page/selections/Workflow')

const routes = [
  {
    // shared selection components
    path: 'selection/:equipments(gateways|end-devices)',
    component: Selection,
    props: true,
    children: [
      {
        path: '',
        name: 'currentSelection',
        redirect: 'edit'
      }, {
        path: 'move',
        component: Move,
        props: true
      }, {
        path: 'delete',
        component: Delete,
        props: true
      }, {
        path: 'workflow',
        component: Workflow,
        props: true
      }
    ]
  }, {
    // gateways selection components
    path: 'selection/:equipments(gateways)',
    component: Selection,
    props: true,
    children: [
      {
        path: 'edit',
        component: EditGateways,
        props: true
      }
    ]
  }, {
    // end-devices selection components
    path: 'selection/:equipments(end-devices)',
    component: Selection,
    props: true,
    children: [
      {
        path: 'edit',
        component: EditEndDevices,
        props: true
      }
    ]
  }, {
    // saved selections
    path: 'selections/:equipments(gateways|end-devices)',
    name: 'selections',
    component: Selections,
    props: true
  }
]

export default routes
